import v4 from 'uuid/v4';
import {ASE_GET_STATISTICS} from '../../constants/websocketCommands';

export const ASE_STATISTICS_PENDING = 'ASE_STATISTICS_PENDING';

export const fetchStatistics = ({dealerNumber, countryGroups, solutionGroups}) => dispatch => {
    return dispatch({
        type: ASE_STATISTICS_PENDING,
        aseWebsocket: true,
        command: ASE_GET_STATISTICS,
        payload: {dealerNumber, countryGroups, solutionGroups, correlationId: v4()}
    });
};
